import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { RiFilter2Fill } from "react-icons/ri";
import { FaChevronLeft } from "react-icons/fa";
import { useSelector, shallowEqual } from 'react-redux'
import { AiFillDelete } from "react-icons/ai";
import FilterToggle from "./FilterToggle";
import SelectSearch from "./metronicLayout/components/filterSelect/SelectSearch";
import Select from 'react-select';
import list from './occupationsList'
import { GetCoachesByOrgId, GetSavedFilters, DeleteFilter, GetOccupationList, GetJobSeekerByOrgID, GetUserDetails } from './api'
import AsyncSelect from 'react-select/async';
import { useParams } from 'react-router-dom';
import { useLocation, useHistory } from 'react-router-dom';
import moment from "moment";

const Filter = ({ show, setShow, savedFilter, handleFilter, type, currentFilter }, ref) => {

  const { user } = useSelector(({ auth }) => auth, shallowEqual);

  const [stages, setStages] = useState({
    resume: {
      all: false,
      needsResumeBuilt: false,
      needsResumeReviewed: false,
      resumeInProgress: false,
      resumeCompleted: false,
      clearStatus: false,
    },
    coverLetter: {
      all: false,
      needsCoverLetterBuilt: false,
      needsCoverLetterReviewed: false,
      coverLetterInProgress: false,
      coverLetterCompleted: false,
      clearStatus: false,
    },
    references: {
      all: false,
      needsReferencesBuilt: false,
      needsReferencesReviewed: false,
      referencesInProgress: false,
      referencesCompleted: false,
      clearStatus: false,
    },
    linkedIn: {
      all: false,
      needsLinkedInAccountCreated: false,
      needsProfileFilledOut: false,
      needsLinkedInProfileReviewed: false,
      linkedInInProgress: false,
      linkedInCompleted: false,
      clearStatus: false,
    },
    jobApplications: {
      all: false,
      needsToApplyForJobs: false,
      applyingForJobs: false,
      clearStatus: false,
    },
    registeredJobBoards: {
      all: false,
      zipRecruiter: false,
      indeed: false,
      Monster: false,
      careerBuilder: false,
    },
  })
  const [activites, setActivites] = useState([]);
  const [occupationInterest, setOccupationInterest] = useState([]);
  const [coachList, setCoachList] = useState([]);
  const [OccupationList, setOccupationList] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('')
  const [saveFilter, setSaveFilter] = useState({
    save: false,
    name: ''
  })
  const [jobseekerList, setJobseekerList] = useState([]);

  const [savedList, setSavedList] = useState([]);
  const [pending, setPending] = useState(false);

  const [inputCheck1, setInputCheck1] = useState(false);
  const [inputCheck2, setInputCheck2] = useState(false);

  const [userDetails, setUserDetails] = useState([]);
  
  console.log(show, "show");

  useImperativeHandle(ref, () => ({
    handleClearFilter(){
      setFromDate('');
      setToDate('');
      setOccupationInterest([]);
      setActivites([]);
      setStages({
        resume: {
          all: false,
          needsResumeBuilt: false,
          needsResumeReviewed: false,
          resumeInProgress: false,
          resumeCompleted: false,
          clearStatus: false,
        },
        coverLetter: {
          all: false,
          needsCoverLetterBuilt: false,
          needsCoverLetterReviewed: false,
          coverLetterInProgress: false,
          coverLetterCompleted: false,
          clearStatus: false,
        },
        references: {
          all: false,
          needsReferencesBuilt: false,
          needsReferencesReviewed: false,
          referencesInProgress: false,
          referencesCompleted: false,
          clearStatus: false,
        },
        linkedIn: {
          all: false,
          needsLinkedInAccountCreated: false,
          needsProfileFilledOut: false,
          needsLinkedInProfileReviewed: false,
          linkedInInProgress: false,
          linkedInCompleted: false,
          clearStatus: false,
        },
        jobApplications: {
          all: false,
          needsToApplyForJobs: false,
          applyingForJobs: false,
          clearStatus: false,
        },
        registeredJobBoards: {
          all: false,
          zipRecruiter: false,
          indeed: false,
          Monster: false,
          careerBuilder: false,
        },
      })
      setSaveFilter({
        name: '',
        save: false
      })
      setJobseekerList([])
      setUserDetails([])
    },
    handleClearFromDate(){
      setFromDate('')
    },
    handleClearToDate(){
      setToDate('')
    },
    handleClearOccupationInterest(value){
      setOccupationInterest(value)
    },
    handleClearActivities(value){
      setActivites(value)
    },
    handleClearStage(value){
      switch(value){
        case 'resume':
          setStages((pre)=>({
            ...pre,
            resume: {
              all: false,
              needsResumeBuilt: false,
              needsResumeReviewed: false,
              resumeInProgress: false,
              resumeCompleted: false,
              clearStatus: false,
            }
          }))
          break;
        case 'coverLetter':
          setStages((pre)=>({
            ...pre,
            coverLetter: {
              all: false,
              needsCoverLetterBuilt: false,
              needsCoverLetterReviewed: false,
              coverLetterInProgress: false,
              coverLetterCompleted: false,
              clearStatus: false,
            },
          }))
          break;
        case 'references':
          setStages((pre)=>({
            ...pre,
            references: {
              all: false,
              needsReferencesBuilt: false,
              needsReferencesReviewed: false,
              referencesInProgress: false,
              referencesCompleted: false,
              clearStatus: false,
            },
          }))
          break;
        case 'linkedIn':
          setStages((pre)=>({
            ...pre,
            linkedIn: {
              all: false,
              needsLinkedInAccountCreated: false,
              needsProfileFilledOut: false,
              needsLinkedInProfileReviewed: false,
              linkedInInProgress: false,
              linkedInCompleted: false,
              clearStatus: false,
            },
          }))
          break;
        case 'jobApplications':
          setStages((pre)=>({
            ...pre,
            jobApplications: {
              all: false,
              needsToApplyForJobs: false,
              applyingForJobs: false,
              clearStatus: false,
            },
          }))
          break;
        case 'registeredJobBoards':
          setStages((pre)=>({
            ...pre,
            registeredJobBoards: {
              all: false,
              zipRecruiter: false,
              indeed: false,
              Monster: false,
              careerBuilder: false,
            },
          }))
          break;
        default: 
          break;
      }
    },
    handleApplyFilter(value){
      alert('allpp')
      handleApply(value)
    },
    handleClearJobseeker(jobseekers){
      setJobseekerList(jobseekers)
    },
    handleClearUserDetails(value = []){
      setUserDetails(value)
    }
  }));

  const history = useHistory();

  useEffect(()=>{
    let data = list.map(e=>{
      return {
        value: e,
        label: e
      }
    })
    setOccupationList(data);
  },[])

  useEffect(()=>{
    if(currentFilter){
      // console.log(currentFilter);
      handleSetSavedFilter({query: currentFilter})
    }
  }, [currentFilter])

  const handleApply = async (query = null) => {
    let tempStages = {};
    for(let stage in stages){
      for(let key in stages[stage]){
        if(key != 'all' && stages[stage][key]){
          console.log([stage][key]);
          tempStages = {
            ...tempStages,
            [stage]: {
              ...tempStages[stage],
              [key]: stages[stage][key]
            }
          }
          // [tempStages[stage][key]] = stages[stage][key]
        }
      }
    }
    let tempActivities = activites.filter(e=>e!='all');

    let filter = {
      stages: tempStages,
      activities: tempActivities,
      occupationInterest: occupationInterest.map(e=>e.value),
      from: fromDate,
      to: toDate,
      jobseekers: jobseekerList,
      userDetails: userDetails
    }
    if(saveFilter.save && saveFilter.name == ''){
      alert('Please enter filter name before save');
      return ;
    }
    if(saveFilter.save && saveFilter.name != ''){
      filter.save = true;
      filter.name = saveFilter.name
    }

    console.log(query);
    if(!query){
      await handleFilter(filter)
      // alert('yes')
      if(saveFilter.save && saveFilter.name != ''){
        handleGetSavedFilter();
        setSaveFilter({
          save: false,
          name: ''
        })
      }
    }else{
      handleFilter(query)
    }
    console.log(filter);
  }
  const handleGetSavedFilter = async ()=> {
    setPending(true)
    try{
      let res = await GetSavedFilters(user.id, type);
      setSavedList(res.filters)
    }catch(ex){
      console.log(ex);
    }finally{
      setPending(false)
    }
  }
  const handleGetCoaches = async (inputValue)=>{
    let res = await GetCoachesByOrgId(user.organization, inputValue);
    return res.coaches.map(e=>{
      return {
        label: `${e.firstName} ${e.lastName}`,
        value: e._id
      }
    })
  }
  const handleGetOccupationInterest = async (inputValue)=>{
    let res = await GetOccupationList(inputValue);
    return res.list.map(e=>{
      return {
        label: e.name,
        value:e.name
      }
    })
  }

  const handleGetUserDetails = async (inputValue) => {
    let res = await GetUserDetails(user.organization, inputValue);
    let data = res;

    const groupedOptions = [
        {
            label: "Source",
            options: data.sources.map((item) => ({ label: item, value: item, type: "source" })),
        },
        {
            label: "Platform",
            options: data.platforms.map((item) => ({ label: item, value: item, type: "platform" })),
        },
        {
            label: "Birth Date",
            options: data.birthDates.map((item) => ({ label: moment(item).format("YYYY-MM-DD"), value: item, type: "birthDate" })),
        },
        {
            label: "First Name",
            options: data.firstNames.map((item) => ({ label: item, value: item, type: "firstName" })),
        },
        {
            label: "Last Name",
            options: data.lastNames.map((item) => ({ label: item, value: item, type: "lastName" })),
        },
        {
            label: "Gender",
            options: data.genders.map((item) => ({ label: item, value: item, type: "gender" })),
        }
    ];

    return groupedOptions;
};

  // useEffect(()=>{
  //   handleGetSavedFilter();
  // }, [])
  const handleSetSavedFilter = (filter) => {
    let Query = {};
    if(filter.query.from){
      setFromDate(filter.query.from)
      Query.from = filter.query.from
    }
    if(filter.query.to){
      setToDate(filter.query.to)
      Query.to = filter.query.to
    }
    if(filter.query.activities){
      setActivites(filter.query.activities)
      Query.activities = filter.query.activities
    }
    if(filter.query.occupationInterest){
      setOccupationInterest(filter.query.occupationInterest.map(e=>({
        label: e,
        value: e
      })))
      Query.occupationInterest = filter.query.occupationInterest
    }
    if(filter.query.jobseekers){
      setJobseekerList(filter.query.jobseekers)
      Query.jobseekers = filter.query.jobseekers
    }
    if(filter.query.stages){
      let temp = stages;
      for(let stage in filter.query.stages){
        for(let key in filter.query.stages[stage]){
          temp = {
            ...temp,
            [stage]: {
              ...temp[stage],
              [key]: filter.query.stages[stage][key]
            }
          }
        }
      }
      let tempStages = {};
      for(let stage in temp){
        for(let key in temp[stage]){
          if(key != 'all' && temp[stage][key]){
            console.log([stage][key]);
            tempStages = {
              ...tempStages,
              [stage]: {
                ...tempStages[stage],
                [key]: temp[stage][key]
              }
            }
            // [tempStages[stage][key]] = stages[stage][key]
          }
        }
      }
      setStages(temp)
      Query.stages = tempStages
    }

    handleApply(Query);
    console.log(Query);
    savedFilter(filter.name)
  }
  // const handleDeleteFilter = async (filter) => {
  //   try{
  //     let res = await DeleteFilter(filter._id);
  //     handleGetSavedFilter();
  //   }catch(ex){
  //     console.log(ex);
  //   }
  // }
  useEffect(()=>{ 
    console.log(user.organization, 'yes tes tess');
  }, [user])

  const handleGetJobseeker = async (inputValue)=>{
    let res = await GetJobSeekerByOrgID(user.organization, inputValue);
    return res.data.map(e=>{
      return {
        label: `${e.firstName} ${e.lastName}`,
        value: e._id
      }
    })
  }


  const location = useLocation();
  const isCoachPage = location.pathname == '/choches'

  return (
    <div className={`container-fluid position`} style={{position:"fixed" , width:"21.7rem"}}>
    {/* <div className={`${show ? "d-none" : ""} container-fluid position`}> */}
      <div className="container pt-5  m-0 p-0">
        <div className="d-flex align-items-center    justify-content-between py-3">
          <div className="  d-flex align-items-center">
            <RiFilter2Fill className="font2" />
            <p className="  text-black font-weight-bold font3 mt-4 ml-2">
              Filters
            </p>
          </div>

          <div
            className="bg-primary  primary d-flex justify-content-center align-items-center"
            onClick={() => {history.push('/reportoverview/job-seeker')}}
          >
            <FaChevronLeft className="text-white font-bold icon" />
          </div>
        </div>

        {/* <FilterToggle title="My Saved Search" className="" top="mt-5">
        { !pending && savedList.length == 0 && <span className="border-none pl-3 bgc py-2 text-dark d-block">No Saved Filters</span> }
          { pending && <div className="w-100 d-flex align-items-center justify-content-between mb-2" >
                  <div class="spinner-border text-danger mx-auto" role="status"></div>
              </div>  }
          { !pending && savedList.map((filter, i)=>{
            return <div className="d-flex justify-content-between bgc">
                <span key={i} style={{width: '90%'}} onClick={()=>{handleSetSavedFilter(filter)}} className="border-none pl-3  py-2 text-dark d-block">
                  { filter.name }
                </span>
                <button onClick={()=>{handleDeleteFilter(filter)}} style={{width: '10%'}} className="bg-transparent border-0">
                  <AiFillDelete className="icon"/>
              </button>
            </div>
          }) }
        </FilterToggle> */}
        {/* {
          !isCoachPage &&

        <FilterToggle title="Choose Coaches" className="" top="mt-5">
          <div className="">
            <AsyncSelect 
              isClearable
              isMulti
              value={coachList}
              onChange={(value)=>{
                if(!value){
                  setCoachList([])
                }else{
                  setCoachList(value)
                }
              }}
              cacheOptions
              defaultOptions
              loadOptions={handleGetCoaches}
              placeholder={'Search by Name or Email'}
            />
          </div>
        </FilterToggle>
} */}
  <FilterToggle title="Choose Profile Details" className="" top="mt-5">
      <div>
      <AsyncSelect
        isClearable
        isMulti
        onChange={(value)=>{
          if(!value){
            setUserDetails([])
          }else{
            setUserDetails(value)
          }
          // console.log(value);
        }}
        value={userDetails}
        cacheOptions
        defaultOptions
        loadOptions={handleGetUserDetails}
        placeholder="Search"
      />
      </div>

    </FilterToggle>
  <FilterToggle title="Choose Stage" className="" top="mt-5">
          
          <FilterToggle title="Resume" className=" border-0 bgc " span1="text-dark" padding="py-2" iconClass="text-dark">

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc'
            onClick={()=>{
              if(!stages.resume.all){
                setStages((pre)=>({...pre, 
                  resume:{ 
                    all: true,
                    needsResumeBuilt: true,
                    needsResumeReviewed: true,
                    resumeInProgress: true,
                    resumeCompleted: true,
                    clearStatus: true 
                    }
                  }))
              }else{
                setStages((pre)=>({...pre, 
                  resume:{ 
                    all: false,
                    needsResumeBuilt: false,
                    needsResumeReviewed: false,
                    resumeInProgress: false,
                    resumeCompleted: false,
                    clearStatus: false 
                    }
                  }))
              }
              }}
          >
            <label className=" border-0 text-dark d-block text-dark pt-2">All</label>
            <input id='one2' type="checkbox" checked={stages.resume.all} onChange={()=>{
              if(!stages.resume.all){
                setStages((pre)=>({...pre, 
                  resume:{ 
                    all: true,
                    needsResumeBuilt: true,
                    needsResumeReviewed: true,
                    resumeInProgress: true,
                    resumeCompleted: true,
                    clearStatus: true 
                    }
                  }))
              }else{
                setStages((pre)=>({...pre, 
                  resume:{ 
                    all: false,
                    needsResumeBuilt: false,
                    needsResumeReviewed: false,
                    resumeInProgress: false,
                    resumeCompleted: false,
                    clearStatus: false 
                    }
                  }))
              }
              }} className='' />
          </div>

          <div onClick={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, needsResumeBuilt: !stages.resume.needsResumeBuilt}}))}} className='d-flex  justify-content-between px-5 align-items-center py-0 bgc'>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs Resume Built</label>
            <input id='two2' checked={stages.resume.needsResumeBuilt} onChange={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, needsResumeBuilt: !stages.resume.needsResumeBuilt}}))}} type="checkbox" className='' />
          </div>
          
          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, needsResumeReviewed: !stages.resume.needsResumeReviewed}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs Resume Reviewed</label>
            <input id='three2' checked={stages.resume.needsResumeReviewed} onChange={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, needsResumeReviewed: !stages.resume.needsResumeReviewed}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, resumeInProgress: !stages.resume.resumeInProgress}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Resume In Progress</label>
            <input id='four2' checked={stages.resume.resumeInProgress} onChange={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, resumeInProgress: !stages.resume.resumeInProgress}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, resumeCompleted: !stages.resume.resumeCompleted}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Resume Completed</label>
            <input id='five2' checked={stages.resume.resumeCompleted} onChange={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, resumeCompleted: !stages.resume.resumeCompleted}}))}} type="checkbox" className='' />
          </div>  

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, clearStatus: !stages.resume.clearStatus}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Clear Status</label>
            <input id='six2' checked={stages.resume.clearStatus} onChange={()=>{setStages((pre)=>({...pre, resume: {...stages.resume, clearStatus: !stages.resume.clearStatus}}))}} type="checkbox" className='' />
          </div>  
          </FilterToggle>
         
          <FilterToggle title="Cover Letter" className="bgc border-0" span1="text-dark" padding="py-2" iconClass="text-dark" >

      
          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc'
            onClick={()=>{
              if(!stages.coverLetter.all){
                setStages((pre)=>({...pre, 
                  coverLetter:{ 
                    all: true,
                    needsCoverLetterBuilt: true,
                    needsCoverLetterReviewed: true,
                    coverLetterInProgress: true,
                    coverLetterCompleted: true,
                    clearStatus: true,
                    }
                  }))
              }else{
                setStages((pre)=>({...pre, 
                  coverLetter:{ 
                    all: false,
                    needsCoverLetterBuilt: false,
                    needsCoverLetterReviewed: false,
                    coverLetterInProgress: false,
                    coverLetterCompleted: false,
                    clearStatus: false,
                    }
                  }))
              }
            }}
          >
            <label className=" border-0 text-dark d-block text-dark pt-2">All</label>
            <input id='one3' checked={stages.coverLetter.all} onChange={
              ()=>{
                if(!stages.coverLetter.all){
                  setStages((pre)=>({...pre, 
                    coverLetter:{ 
                      all: true,
                      needsCoverLetterBuilt: true,
                      needsCoverLetterReviewed: true,
                      coverLetterInProgress: true,
                      coverLetterCompleted: true,
                      clearStatus: true,
                      }
                    }))
                }else{
                  setStages((pre)=>({...pre, 
                    coverLetter:{ 
                      all: false,
                      needsCoverLetterBuilt: false,
                      needsCoverLetterReviewed: false,
                      coverLetterInProgress: false,
                      coverLetterCompleted: false,
                      clearStatus: false,
                      }
                    }))
                }
              }
            } type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, needsCoverLetterBuilt: !stages.coverLetter.needsCoverLetterBuilt}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs Cover Letter Built</label>
            <input id='two3' checked={stages.coverLetter.needsCoverLetterBuilt} onChange={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, needsCoverLetterBuilt: !stages.coverLetter.needsCoverLetterBuilt}}))}} type="checkbox" className='' />
          </div>
          
          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, needsCoverLetterReviewed: !stages.coverLetter.needsCoverLetterReviewed}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs Cover Letter Reviewed</label>
            <input id='three3' checked={stages.coverLetter.needsCoverLetterReviewed} onChange={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, needsCoverLetterReviewed: !stages.coverLetter.needsCoverLetterReviewed}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, coverLetterInProgress: !stages.coverLetter.coverLetterInProgress}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Cover Letter In Progress</label>
            <input id='four3' checked={stages.coverLetter.coverLetterInProgress} onChange={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, coverLetterInProgress: !stages.coverLetter.coverLetterInProgress}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, coverLetterCompleted: !stages.coverLetter.coverLetterCompleted}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Cover Letter Completed</label>
            <input id='five3' checked={stages.coverLetter.coverLetterCompleted} onChange={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, coverLetterCompleted: !stages.coverLetter.coverLetterCompleted}}))}} type="checkbox" className='' />
          </div>  

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, clearStatus: !stages.coverLetter.clearStatus}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Clear Status</label>
            <input id='six3' checked={stages.coverLetter.clearStatus} onChange={()=>{setStages((pre)=>({...pre, coverLetter: {...stages.coverLetter, clearStatus: !stages.coverLetter.clearStatus}}))}} type="checkbox" className='' />
          </div>  

          </FilterToggle>

          <FilterToggle title="References" className="bgc border-0" span1="text-dark" padding="py-2" iconClass="text-dark">

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc'
            onClick={()=>{
              if(!stages.references.all){
                setStages((pre)=>({...pre, 
                  references:{ 
                    all: true,
                    needsReferencesBuilt: true,
                    needsReferencesReviewed: true,
                    referencesInProgress: true,
                    referencesCompleted: true,
                    clearStatus: true,
                    }
                  }))
              }else{
                setStages((pre)=>({...pre, 
                  references:{ 
                    all: false,
                    needsReferencesBuilt: false,
                    needsReferencesReviewed: false,
                    referencesInProgress: false,
                    referencesCompleted: false,
                    clearStatus: false,
                    }
                  }))
              }
            }}
          >
            <label className=" border-0 text-dark d-block text-dark pt-2">All</label>
            <input id='one4' checked={stages.references.all} onChange={
              ()=>{
                if(!stages.references.all){
                  setStages((pre)=>({...pre, 
                    references:{ 
                      all: true,
                      needsReferencesBuilt: true,
                      needsReferencesReviewed: true,
                      referencesInProgress: true,
                      referencesCompleted: true,
                      clearStatus: true,
                      }
                    }))
                }else{
                  setStages((pre)=>({...pre, 
                    references:{ 
                      all: false,
                      needsReferencesBuilt: false,
                      needsReferencesReviewed: false,
                      referencesInProgress: false,
                      referencesCompleted: false,
                      clearStatus: false,
                      }
                    }))
                }
              }
            } type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, references: {...stages.references, needsReferencesBuilt: !stages.references.needsReferencesBuilt}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs References Built</label>
            <input id='two4' checked={stages.references.needsReferencesBuilt} onChange={()=>{setStages((pre)=>({...pre, references: {...stages.references, needsReferencesBuilt: !stages.references.needsReferencesBuilt}}))}} type="checkbox" className='' />
          </div>
          
          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, references: {...stages.references, needsReferencesReviewed: !stages.references.needsReferencesReviewed}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs References Reviewed</label>
            <input id='one' checked={stages.references.needsReferencesReviewed} onChange={()=>{setStages((pre)=>({...pre, references: {...stages.references, needsReferencesReviewed: !stages.references.needsReferencesReviewed}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, references: {...stages.references, referencesInProgress: !stages.references.referencesInProgress}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">References In Progress</label>
            <input id='three4' checked={stages.references.referencesInProgress} onChange={()=>{setStages((pre)=>({...pre, references: {...stages.references, referencesInProgress: !stages.references.referencesInProgress}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, references: {...stages.references, referencesCompleted: !stages.references.referencesCompleted}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">References Completed</label>
            <input id='one' checked={stages.references.referencesCompleted} onChange={()=>{setStages((pre)=>({...pre, references: {...stages.references, referencesCompleted: !stages.references.referencesCompleted}}))}} type="checkbox" className='' />
          </div>  


          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, references: {...stages.references, clearStatus: !stages.references.clearStatus}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Clear Status</label>
            <input id='five4' checked={stages.references.clearStatus} onChange={()=>{setStages((pre)=>({...pre, references: {...stages.references, clearStatus: !stages.references.clearStatus}}))}} type="checkbox" className='' />
            </div>
          </FilterToggle>

          <FilterToggle title="Linked In" className="bgc border-0" span1="text-dark" padding="py-2" iconClass="text-dark">
          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc'
            onClick={
              ()=>{
                if(!stages.linkedIn.all){
                  setStages((pre)=>({...pre, 
                    linkedIn:{ 
                      all: true,
                      needsLinkedInAccountCreated: true,
                      needsProfileFilledOut: true,
                      needsLinkedInProfileReviewed: true,
                      linkedInInProgress: true,
                      linkedInCompleted: true,
                      clearStatus: true,
                      }
                    }))
                }else{
                  setStages((pre)=>({...pre, 
                    linkedIn:{ 
                      all: false,
                      needsLinkedInAccountCreated: false,
                      needsProfileFilledOut: false,
                      needsLinkedInProfileReviewed: false,
                      linkedInInProgress: false,
                      linkedInCompleted: false,
                      clearStatus: false,
                      }
                    }))
                }
              }
            }
          >
            <label className=" border-0 text-dark d-block text-dark pt-2">All</label>
            <input id='one5' checked={stages.linkedIn.all} onChange={
              ()=>{
                if(!stages.linkedIn.all){
                  setStages((pre)=>({...pre, 
                    linkedIn:{ 
                      all: true,
                      needsLinkedInAccountCreated: true,
                      needsProfileFilledOut: true,
                      needsLinkedInProfileReviewed: true,
                      linkedInInProgress: true,
                      linkedInCompleted: true,
                      clearStatus: true,
                      }
                    }))
                }else{
                  setStages((pre)=>({...pre, 
                    linkedIn:{ 
                      all: false,
                      needsLinkedInAccountCreated: false,
                      needsProfileFilledOut: false,
                      needsLinkedInProfileReviewed: false,
                      linkedInInProgress: false,
                      linkedInCompleted: false,
                      clearStatus: false,
                      }
                    }))
                }
              }
            } type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, needsLinkedInAccountCreated: !stages.linkedIn.needsLinkedInAccountCreated}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs Linked In Account Created</label>
            <input id='two5' checked={stages.linkedIn.needsLinkedInAccountCreated} onChange={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, needsLinkedInAccountCreated: !stages.linkedIn.needsLinkedInAccountCreated}}))}} type="checkbox" className='' />
          </div>
          
          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, needsProfileFilledOut: !stages.linkedIn.needsProfileFilledOut}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs Profile Filled Out</label>
            <input id='three5' checked={stages.linkedIn.needsProfileFilledOut} onChange={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, needsProfileFilledOut: !stages.linkedIn.needsProfileFilledOut}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, needsLinkedInProfileReviewed: !stages.linkedIn.needsLinkedInProfileReviewed}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs Linked In Profile Reviewed</label>
            <input id='four5' checked={stages.linkedIn.needsLinkedInProfileReviewed} onChange={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, needsLinkedInProfileReviewed: !stages.linkedIn.needsLinkedInProfileReviewed}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, linkedInInProgress: !stages.linkedIn.linkedInInProgress}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Linked In In Progress</label>
            <input id='five5' checked={stages.linkedIn.linkedInInProgress} onChange={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, linkedInInProgress: !stages.linkedIn.linkedInInProgress}}))}} type="checkbox" className='' />
          </div>  


          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, linkedInCompleted: !stages.linkedIn.linkedInCompleted}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Linked In Completed</label>
            <input id='five5' checked={stages.linkedIn.linkedInCompleted} onChange={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, linkedInCompleted: !stages.linkedIn.linkedInCompleted}}))}} type="checkbox" className='' />
          </div>  

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, clearStatus: !stages.linkedIn.clearStatus}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Clear Status</label>
            <input id='six5' checked={stages.linkedIn.clearStatus} onChange={()=>{setStages((pre)=>({...pre, linkedIn: {...stages.linkedIn, clearStatus: !stages.linkedIn.clearStatus}}))}} type="checkbox" className='' />
            </div>
          </FilterToggle>

          <FilterToggle title="Job Applications" className="bgc border-0" span1="text-dark" padding="py-2" iconClass="text-dark">
          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc'
            onClick={
              ()=>{
                if(!stages.jobApplications.all){
                  setStages((pre)=>({...pre, 
                    jobApplications:{ 
                      all: true,
                      needsToApplyForJobs: true,
                      applyingForJobs: true,
                      clearStatus: true,
                      }
                    }))
                }else{
                  setStages((pre)=>({...pre, 
                    jobApplications:{ 
                      all: false,
                      needsToApplyForJobs: false,
                      applyingForJobs: false,
                      clearStatus: false,
                      }
                    }))
                }
              }
            }
          >
            <label className=" border-0 text-dark d-block text-dark pt-2">All</label>
            <input id='one6' checked={stages.jobApplications.all} onChange={
              ()=>{
                if(!stages.jobApplications.all){
                  setStages((pre)=>({...pre, 
                    jobApplications:{ 
                      all: true,
                      needsToApplyForJobs: true,
                      applyingForJobs: true,
                      clearStatus: true,
                      }
                    }))
                }else{
                  setStages((pre)=>({...pre, 
                    jobApplications:{ 
                      all: false,
                      needsToApplyForJobs: false,
                      applyingForJobs: false,
                      clearStatus: false,
                      }
                    }))
                }
              }
            } type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, jobApplications: {...stages.jobApplications, needsToApplyForJobs: !stages.jobApplications.needsToApplyForJobs}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Needs To Apply For Jobs</label>
            <input id='two6' checked={stages.jobApplications.needsToApplyForJobs} onChange={()=>{setStages((pre)=>({...pre, jobApplications: {...stages.jobApplications, needsToApplyForJobs: !stages.jobApplications.needsToApplyForJobs}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, jobApplications: {...stages.jobApplications, applyingForJobs: !stages.jobApplications.applyingForJobs}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Applying For Jobs</label>
            <input id='one' checked={stages.jobApplications.applyingForJobs} onChange={()=>{setStages((pre)=>({...pre, jobApplications: {...stages.jobApplications, applyingForJobs: !stages.jobApplications.applyingForJobs}}))}} type="checkbox" className='' />
          </div>  

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, jobApplications: {...stages.jobApplications, clearStatus: !stages.jobApplications.clearStatus}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Clear Status</label>
            <input id='three6' checked={stages.jobApplications.clearStatus} onChange={()=>{setStages((pre)=>({...pre, jobApplications: {...stages.jobApplications, clearStatus: !stages.jobApplications.clearStatus}}))}} type="checkbox" className='' />
          </div> 
          </FilterToggle>

          <FilterToggle title="Registered Job Boards" className="bgc border-0" span1="text-dark" padding="py-2" iconClass="text-dark" >
          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc'
            onClick={
              ()=>{
                if(!stages.registeredJobBoards.all){
                  setStages((pre)=>({...pre, 
                    registeredJobBoards:{ 
                      all: true,
                      zipRecruiter: true,
                      indeed: true,
                      Monster: true,
                      careerBuilder: true, 
                      }
                    }))
                }else{
                  setStages((pre)=>({...pre, 
                    registeredJobBoards:{ 
                      all: false,
                      zipRecruiter: false,
                      indeed: false,
                      Monster: false,
                      careerBuilder: false,  
                      }
                    }))
                }
              }
            }
          >
            <label className=" border-0 text-dark d-block text-dark pt-2">All</label>
            <input id='one7' checked={stages.registeredJobBoards.all} onChange={
              ()=>{
                if(!stages.registeredJobBoards.all){
                  setStages((pre)=>({...pre, 
                    registeredJobBoards:{ 
                      all: true,
                      zipRecruiter: true,
                      indeed: true,
                      Monster: true,
                      careerBuilder: true, 
                      }
                    }))
                }else{
                  setStages((pre)=>({...pre, 
                    registeredJobBoards:{ 
                      all: false,
                      zipRecruiter: false,
                      indeed: false,
                      Monster: false,
                      careerBuilder: false,  
                      }
                    }))
                }
              }
            } type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, registeredJobBoards: {...stages.registeredJobBoards, zipRecruiter: !stages.registeredJobBoards.zipRecruiter}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Zip Recruiter</label>
            <input id='two7' checked={stages.registeredJobBoards.zipRecruiter} onChange={()=>{setStages((pre)=>({...pre, registeredJobBoards: {...stages.registeredJobBoards, zipRecruiter: !stages.registeredJobBoards.zipRecruiter}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, registeredJobBoards: {...stages.registeredJobBoards, indeed: !stages.registeredJobBoards.indeed}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Indeed</label>
            <input id='three7' checked={stages.registeredJobBoards.indeed} onChange={()=>{setStages((pre)=>({...pre, registeredJobBoards: {...stages.registeredJobBoards, indeed: !stages.registeredJobBoards.indeed}}))}} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, registeredJobBoards: {...stages.registeredJobBoards, Monster: !stages.registeredJobBoards.Monster}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Monster</label>
            <input id='four7' checked={stages.registeredJobBoards.Monster} onChange={()=>{setStages((pre)=>({...pre, registeredJobBoards: {...stages.registeredJobBoards, Monster: !stages.registeredJobBoards.Monster}}))}} type="checkbox" className='' />
          </div>  

          <div className='d-flex  justify-content-between px-5 align-items-center py-0 bgc' onClick={()=>{setStages((pre)=>({...pre, registeredJobBoards: {...stages.registeredJobBoards, careerBuilder: !stages.registeredJobBoards.careerBuilder}}))}}>
            <label className=" border-0 text-dark d-block text-dark pt-2">Career Builder</label>
            <input id='five7' checked={stages.registeredJobBoards.careerBuilder} onChange={()=>{setStages((pre)=>({...pre, registeredJobBoards: {...stages.registeredJobBoards, careerBuilder: !stages.registeredJobBoards.careerBuilder}}))}} type="checkbox" className='' />
          </div> 
          </FilterToggle>

          {/* <FilterToggle title="User Placed" className="bgc border-0" span1="text-dark" padding="py-2" iconClass="text-dark d-none"></FilterToggle> */}

        </FilterToggle>

        <FilterToggle title="Choose Jobseeker" className="" top="mt-5">
          <div className="">
            <AsyncSelect 
              isClearable
              isMulti
              value={jobseekerList}
              onChange={(value)=>{
                if(!value){
                  setJobseekerList([])
                }else{
                  setJobseekerList(value)
                }
              }}
              cacheOptions
              defaultOptions
              loadOptions={handleGetJobseeker}
              placeholder={'Search by Name or Email'}
            />
          </div>
        </FilterToggle>

        <FilterToggle title="Choose Occupation" className="" top="mt-5">
          <div>
          <AsyncSelect
            isClearable
            isMulti
            onChange={(value)=>{
              if(!value){
                setOccupationInterest([])
              }else{
                setOccupationInterest(value)
              }
              // console.log(value);
            }}
            value={occupationInterest}
            cacheOptions
            defaultOptions
            loadOptions={handleGetOccupationInterest}
            placeholder="Search"
          />
          </div>

          {/* <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'>
            <label className=" border-0 text-dark d-block text-dark pt-2" for="one">Business Manager</label>
            <input id='one' checked={occupationInterest.includes('Business Manager')} onChange={()=>{
              if(occupationInterest.includes('Business Manager')){
                setOccupationInterest(occupationInterest.filter(e=>e!='Business Manager'))
              }else{
                setOccupationInterest([...occupationInterest, 'Business Manager'])
              }
            }} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'>
            <label className=" border-0 text-dark  d-block text-dark pt-2" for="two">Facilities Manager</label>
            <input id='two' checked={occupationInterest.includes('Facilities Manager')} onChange={()=>{
              if(occupationInterest.includes('Facilities Manager')){
                setOccupationInterest(occupationInterest.filter(e=>e!='Facilities Manager'))
              }else{
                setOccupationInterest([...occupationInterest, 'Facilities Manager'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'>
            <label className=" border-0 text-dark d-block text-dark pt-2" for="three" >Operations Director</label>
            <input id='three' checked={occupationInterest.includes('Operations Director')} onChange={()=>{
              if(occupationInterest.includes('Operations Director')){
                setOccupationInterest(occupationInterest.filter(e=>e!='Operations Director'))
              }else{
                setOccupationInterest([...occupationInterest, 'Operations Director'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'>
            <label className=" border-0 text-dark  d-block text-dark pt-2" for="four">Plant Manager</label>
            <input id='four' checked={occupationInterest.includes('Plant Manager')} onChange={()=>{
              if(occupationInterest.includes('Plant Manager')){
                setOccupationInterest(occupationInterest.filter(e=>e!='Plant Manager'))
              }else{
                setOccupationInterest([...occupationInterest, 'Plant Manager'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex justify-content-between px-3 align-items-center py-0 bgc' >
            <label className=" border-0 text-dark  d-block text-dark pt-2" for="five">Store Manager</label>
            <input id='five' checked={occupationInterest.includes('Store Manager')} onChange={()=>{
              if(occupationInterest.includes('Store Manager')){
                setOccupationInterest(occupationInterest.filter(e=>e!='Store Manager'))
              }else{
                setOccupationInterest([...occupationInterest, 'Store Manager'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex justify-content-between px-3 align-items-center py-0 bgc'>
            <label className=" border-0 text-dark  d-block text-dark pt-2" for="six">President</label>
            <input id='six' checked={occupationInterest.includes('President')} onChange={()=>{
              if(occupationInterest.includes('President')){
                setOccupationInterest(occupationInterest.filter(e=>e!='President'))
              }else{
                setOccupationInterest([...occupationInterest, 'President'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'>
            <label className=" border-0 text-dark  d-block text-dark pt-2" for="seven">Sales Director</label>
            <input id='seven' checked={occupationInterest.includes('Sales Director')} onChange={()=>{
              if(occupationInterest.includes('Sales Director')){
                setOccupationInterest(occupationInterest.filter(e=>e!='Sales Director'))
              }else{
                setOccupationInterest([...occupationInterest, 'Sales Director'])
              }
            }} type="checkbox" />
          </div> */}

        </FilterToggle>

        <FilterToggle title="Choose Activity" className="" top="mt-5">

          <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc' onClick={
            ()=>{
              if(!activites.includes('all')){
                setActivites(['all', 'Text', 'Call', 'Email', 'Meeting', 'Note', 'Other'])
              }else{
                setActivites([])
              }
            }
          }>
            <label className=" border-0 text-dark d-block text-dark pt-2">All</label>
            <input id='one1' checked={activites.includes('all')} onChange={()=>{
              if(!activites.includes('all')){
                setActivites(['all', 'Text', 'Call', 'Email', 'Meeting', 'Note', 'Other'])
              }else{
                setActivites([])
              }
            }} type="checkbox" className='' />
          </div>

          <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc' 
            onClick={
              ()=>{
                if(activites.includes('Call')){
                  setActivites(activites.filter(e=>e!='Call'))
                }else{
                  setActivites([...activites, 'Call'])
                }
              }
            }
          >
            <label className=" border-0 text-dark  d-block text-dark pt-2">Call</label>
            <input id='two1' checked={activites.includes('Call')} onChange={()=>{
              if(activites.includes('Call')){
                setActivites(activites.filter(e=>e!='Call'))
              }else{
                setActivites([...activites, 'Call'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'
            onClick={()=>{
              if(activites.includes('Email')){
                setActivites(activites.filter(e=>e!='Email'))
              }else{
                setActivites([...activites, 'Email'])
              }
            }}
          >
            <label className=" border-0 text-dark d-block text-dark pt-2" >Email</label>
            <input id='three1' checked={activites.includes('Email')} onChange={()=>{
              if(activites.includes('Email')){
                setActivites(activites.filter(e=>e!='Email'))
              }else{
                setActivites([...activites, 'Email'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'
            onClick={
              ()=>{
                if(activites.includes('Text')){
                  setActivites(activites.filter(e=>e!='Text'))
                }else{
                  setActivites([...activites, 'Text'])
                }
              }
            }
          >
            <label className=" border-0 text-dark  d-block text-dark pt-2">Text</label>
            <input id='four1' checked={activites.includes('Text')} onChange={()=>{
              if(activites.includes('Text')){
                setActivites(activites.filter(e=>e!='Text'))
              }else{
                setActivites([...activites, 'Text'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex justify-content-between px-3 align-items-center py-0 bgc' 
            onClick={
              ()=>{
                if(activites.includes('Meeting')){
                  setActivites(activites.filter(e=>e!='Meeting'))
                }else{
                  setActivites([...activites, 'Meeting'])
                }
              }
            }
          >
            <label className=" border-0 text-dark  d-block text-dark pt-2">Meeting</label>
            <input id='five1' checked={activites.includes('Meeting')} onChange={()=>{
              if(activites.includes('Meeting')){
                setActivites(activites.filter(e=>e!='Meeting'))
              }else{
                setActivites([...activites, 'Meeting'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex justify-content-between px-3 align-items-center py-0 bgc'
           onClick={
            ()=>{
              if(activites.includes('Note')){
                setActivites(activites.filter(e=>e!='Note'))
              }else{
                setActivites([...activites, 'Note'])
              }
            }
           }
          >
            <label className=" border-0 text-dark  d-block text-dark pt-2">Note</label>
            <input id='six1' checked={activites.includes('Note')} onChange={()=>{
              if(activites.includes('Note')){
                setActivites(activites.filter(e=>e!='Note'))
              }else{
                setActivites([...activites, 'Note'])
              }
            }} type="checkbox" />
          </div>

          <div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'
            onClick={()=>{
              if(activites.includes('Other')){
                setActivites(activites.filter(e=>e!='Other'))
              }else{
                setActivites([...activites, 'Other'])
              }
            }}
          >
            <label className=" border-0 text-dark  d-block text-dark pt-2">Other</label>
            <input id='seven1' checked={activites.includes('Other')} onChange={()=>{
              if(activites.includes('Other')){
                setActivites(activites.filter(e=>e!='Other'))
              }else{
                setActivites([...activites, 'Other'])
              }
            }} type="checkbox" />
          </div>

        </FilterToggle>

        {/* <FilterToggle title="Choose Time Period" className="" top="mt-5">

          <span onClick={
            ()=>{
              let from = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');
              let to = new Date().toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;

              setFromDate(from);
              setToDate(to)
            }
          } className="border-none pl-3 bgc py-2 text-dark d-block">1 Week</span>
          <span onClick={
            ()=>{
              let from = new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;
              let to = new Date().toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;

              setFromDate(from);
              setToDate(to)
            }
          } className="border-none pl-3 bgc py-2 text-dark d-block">3 Weeks</span>
          <span onClick={
            ()=>{
              let from = new Date(Date.now() - 42 * 24 * 60 * 60 * 1000).toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;
              let to = new Date().toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;

              setFromDate(from);
              setToDate(to)
            }
          } className="border-none pl-3 bgc py-2 text-dark d-block">6 Weeks</span>
          <span onClick={
            ()=>{
              let from = new Date();
              from.setFullYear(from.getFullYear()-1)
              let to = new Date().toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');

              setFromDate(from.toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-'));
              setToDate(to)
            }
          } className="border-none pl-3 bgc py-2 text-dark d-block">1 Year</span>

        </FilterToggle> */}

        <div className='d-flex justify-content-between my-5'>
          <input type='date' value={fromDate} onChange={(e)=>{e.persist(); setFromDate(e.target.value)}} className='py-4 fltr color1 outline-0 outline-none' style={{width:"49%"}}/>
          <input type='date' value={toDate} onChange={(e)=>{e.persist(); setToDate(e.target.value)}} className='py-4 fltr color1 outline-0 outline-none' style={{width:"49%"}}/>
        </div>

        {/* <div className=' d-flex flex-column '>
          <div className='d-flex'>
        <input id="click" checked={saveFilter.save} onChange={()=>{setSaveFilter((pre)=>({...pre, save: !saveFilter.save}))}} type="checkbox"/>
        <label for="click" className='font5 ml-2 mt-2'>Save filter for future use.</label>
        </div>
        { saveFilter.save && <input type="text" value={saveFilter.name} onChange={(e)=>{ e.persist() ;setSaveFilter((pre)=>({...pre, name: e.target.value}))}} placeholder='Enter Filter Name' className='py-4 mt-2 color1 outline-none '/> }
        </div> */}

        <button onClick={()=>{handleApply()}} className='bg_c py-3 border-0 outline-0 w-100'>Apply Filters</button>
      </div>
    </div>
  );
};

export default forwardRef(Filter);
